<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Business Class Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :custom-filter="customSearch"
              :no-data-text="noDataText"
              item-key="key"
              show-select
              v-bind:search="search"
              v-model="selected"
              @input="enterSelect"
              @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected. </div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', 'busCls')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn>
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', 'busCls')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  props: {
    'reportType': String,
    'polType': String,
    'menu': Object
  },
  data() {
    return {
      headers: [
        { text: 'Business Class', value: 'busCls' },
        { text: 'Description', value: 'busClsDesc' }
      ]
    }
  },
  created() {
    this.doInit()
  },
  computed: {
  },
  watch: {
    'menu': function() {
      this.doInit()
    },
    'polType': function() {
      this.doInit()
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.menu.busClsList
      const expand = {
        reportType: this.reportType,
        polType: this.polType
      }
      if (apiURI) {
        this.loading = true
        this.$http.get(expandURI(apiURI, expand)).then(result => {
          this.items = []
          this.selectedItems = []
          const { dataList } = result.data
          if (dataList) {
            dataList.map(busClsList => {
              const convertList = {
                key: busClsList.value,
                busCls: busClsList.value,
                busClsDesc: busClsList.label
              }
              if (this.checkedItems.includes(busClsList.value)) {
                const policyTypeList = {
                  key: busClsList.value,
                  busCls: busClsList.value,
                  busClsDesc: busClsList.label
                }
                this.selectedItems.push(policyTypeList)
              }
              this.items.push(convertList)
            })
          }
          if (this.checkedItems.toString() === 'All') {
            this.doReset()
            this.toggleAll()
          } else {
            this.toggleSelected()
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    helpListMixin
  ]
}
</script>
